import { graphQlClient } from '@config/graphqlClient';
import AssistantGraphQL from '@graphql/assistant.queries';
import {
  AssistantAvailableRequest,
  AssistantConversation,
  AssistantConversationRequest,
  LatestAssistantConversationForProjectRequest,
  MyAssistantConversationsRequest,
  SendAssistantMessageInput,
} from '@models/assistant.model';

export const getAssistantAvailable = async (): Promise<boolean> => {
  const data: AssistantAvailableRequest = await graphQlClient.request(AssistantGraphQL.queries.assistantAvailable);
  return !!data.assistantAvailable;
};

export const getAssistantConversation = async (conversationId: string): Promise<AssistantConversation> => {
  const data: AssistantConversationRequest = await graphQlClient.request(
    AssistantGraphQL.queries.assistantConversation,
    { conversationId },
  );
  return data.assistantConversation;
};

export const getMyAssistantConversations = async (): Promise<AssistantConversation[]> => {
  const data: MyAssistantConversationsRequest = await graphQlClient.request(
    AssistantGraphQL.queries.myAssistantConversations,
  );
  return data.myAssistantConversations || [];
};

export const getLatestAssistantConversationForProject = async (
  projectId: string,
): Promise<AssistantConversation | null> => {
  const data: LatestAssistantConversationForProjectRequest = await graphQlClient.request(
    AssistantGraphQL.queries.myLatestAssistantConversationForProject,
    { projectId },
  );
  return data.myLatestAssistantConversationForProject ?? null;
};

export const sendAssistantMessage = async (input: SendAssistantMessageInput): Promise<AssistantConversation> => {
  const data: { sendAssistantMessage: AssistantConversation } = await graphQlClient.request(
    AssistantGraphQL.mutations.sendAssistantMessage,
    { input },
  );
  return data.sendAssistantMessage;
};

export const confirmAssistantAction = async (conversationId: string): Promise<AssistantConversation> => {
  const data: { confirmAssistantAction: AssistantConversation } = await graphQlClient.request(
    AssistantGraphQL.mutations.confirmAssistantAction,
    { conversationId },
  );
  return data.confirmAssistantAction;
};

export const dismissAssistantAction = async (conversationId: string): Promise<AssistantConversation> => {
  const data: { dismissAssistantAction: AssistantConversation } = await graphQlClient.request(
    AssistantGraphQL.mutations.dismissAssistantAction,
    { conversationId },
  );
  return data.dismissAssistantAction;
};

export const deleteAssistantConversation = async (conversationId: string): Promise<boolean> => {
  const data: { deleteAssistantConversation: boolean } = await graphQlClient.request(
    AssistantGraphQL.mutations.deleteAssistantConversation,
    { conversationId },
  );
  return data.deleteAssistantConversation;
};

const assistantService = {
  getAssistantAvailable,
  getAssistantConversation,
  getMyAssistantConversations,
  getLatestAssistantConversationForProject,
  sendAssistantMessage,
  confirmAssistantAction,
  dismissAssistantAction,
  deleteAssistantConversation,
};

export default assistantService;
